const Sponsored = () => {
  return (
    <div className="bg-custom-green-gradient absolute top-0 z-10 w-[82px] h-[21px] p-[4px_8px] rounded-[16px_0px_16px_0px] text-white text-[12px] font-medium leading-[12.88px] text-left">
      Sponsored
    </div>
  );
};

export default Sponsored;
